<!-- eslint-disable @angular-eslint/template/no-duplicate-attributes -->
<div class="flex flex-col gap-2" data-test-id="expert-timeline">
  @for (item of items; track item) {
    <div
      class="timeline-item"
      data-test-id="expert-timeline-item"
      [class]="item.class"
    >
      <ng-container
        [ngTemplateOutlet]="expertTimelineItemTmpl"
        [ngTemplateOutletContext]="{
          icon: item.icon,
          title: item.title,
          dateTime: item.dateTime,
          name: item.name,
          showTimeline: !$last,
        }"
      ></ng-container>
    </div>
  }
</div>

<ng-template
  #expertTimelineItemTmpl
  let-icon="icon"
  let-title="title"
  let-dateTime="dateTime"
  let-name="name"
  let-showTimeline="showTimeline"
>
  <div class="flex gap-2">
    <div class="flex flex-col justify-center items-center timeline-col">
      <mat-icon data-test-id="expert-timeline-item-icon">
        {{ icon }}
      </mat-icon>
      @if (showTimeline) {
        <div>
          <div class="vertical-line"></div>
        </div>
      }
    </div>

    <div class="detail-col flex flex-col">
      <div class="timeline-title" data-test-id="expert-timeline-item-title">
        {{ title }}
      </div>

      @if (name) {
        <div class="timeline-name" data-test-id="expert-timeline-item-name">
          {{ name }}
        </div>
      }

      @if (dateTime) {
        <div
          class="timeline-datetime"
          data-test-id="expert-timeline-item-datetime"
        >
          {{ dateTime | date: 'EEE dd MMMM yyyy' }},
          {{ dateTime | date: 'shortTime' }}
        </div>
      }
    </div>
  </div>
</ng-template>
